import { Outlet } from 'react-router-dom'

/**
 * Shared root shell. Renders the active route's layout (customer, company, or admin)
 * via nested <Outlet /> from React Router.
 */
export default function RootLayout() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Outlet />
    </div>
  )
}
